import React from 'react';

import { ReadMoreButton } from 'components/common/ReadMoreButton';
import { Wrapper } from './atoms/Wrapper';
import { Title } from './atoms/Title';
import { Description } from './atoms/Description';

export interface PayoffProps {
    title: string;
    description: string;
    readMoreUrl?: string;
    isPurple?: boolean;
    extraHeightInPixels?: number;
}
export const PayoffForYou: React.FC<PayoffProps> = ({
    title,
    description,
    readMoreUrl = '',
    isPurple,
    extraHeightInPixels = 0,
}) => (
    <Wrapper extraHeightInPixels={extraHeightInPixels} isPurple={isPurple}>
        <div>
            <Title>{title}</Title>
            <div>
                <Description>{description}</Description>
            </div>
            {readMoreUrl && <ReadMoreButton readMoreUrl={readMoreUrl} />}
        </div>
    </Wrapper>
);
